import { AccessTime, Email, PhoneEnabledSharp } from '@mui/icons-material';
import SocialMedia from './SocialMedia';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

const TopNavBar = () => {
  return (
    <MKBox
      sx={{
        p: 0.5,
        opacity: 0.98,
        bgcolor: '#111',
        color: 'white',
        display: { xs: 'none', md: 'flex' },
        justifyContent: 'space-around',
        alignItems: 'center',
      }}
    >
      <MKBox
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <MKBox
          component='a'
          href='tel:+233302419436'
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              color: 'success',
              cursor: 'pointer',
            },
          }}
        >
          <PhoneEnabledSharp
            color='warning'
            fontSize='small'
            sx={{ marginRight: '0.25rem' }}
          />
          <MKTypography
            fontWeight='regular'
            variant='button'
            color='warning'
            sx={{ marginRight: '1rem' }}
          >
            + (233) 30 241 9436
          </MKTypography>
        </MKBox>
        <MKBox
          component='a'
          href='mailto:csddafrica@gmail.com'
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              color: 'primary.main',
              cursor: 'pointer',
            },
          }}
        >
          <Email
            color='warning'
            fontSize='small'
            sx={{ marginRight: '0.25rem' }}
          />
          <MKTypography fontWeight='regular' variant='button' color='warning'>
            csddafrica@gmail.com
          </MKTypography>
        </MKBox>
      </MKBox>
      <MKBox
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <MKBox
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              color: 'error',
            },
          }}
        >
          <AccessTime
            color='warning'
            fontSize='small'
            sx={{ marginRight: '0.25rem' }}
          />
          <MKTypography
            fontWeight='regular'
            variant='button'
            color='warning'
            sx={{ marginRight: '1rem' }}
          >
            Mon - Fri 8.30 - 17.00
          </MKTypography>
          <SocialMedia marginTop={0.5} />
        </MKBox>
      </MKBox>
    </MKBox>
  );
};
export default TopNavBar;
